import { Button } from 'components/ui'
import { cn } from 'utils/cn'
import { useImpersonation } from 'contexts/ImpersonationContext'

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}

export default function ImpersonationBanner() {
  const { isImpersonating, session, timeRemaining, endImpersonation } = useImpersonation()

  if (!isImpersonating || !session) return null

  return (
    <div className="sticky top-0 z-[9999] w-full bg-danger-600 px-4 py-2 text-content-inverse">
      <div className={cn('flex', 'flex-wrap items-center justify-center gap-x-4 gap-y-1')}>
        <p
          className={cn(
            'text-content-secondary',
            'break-all text-sm font-bold text-content-inverse',
          )}
        >
          Impersonating {session.targetUser.email}
        </p>
        {timeRemaining !== null && (
          <p className={cn('text-content-secondary', 'text-sm text-content-inverse opacity-90')}>
            {formatTime(timeRemaining)} remaining
          </p>
        )}
        <Button
          size="xs"
          variant="solid"
          onClick={endImpersonation}
          className="bg-white/20 text-white hover:bg-white/30"
        >
          End Session
        </Button>
      </div>
    </div>
  )
}
